export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6366.9a6593a2.jpg";